import type { IInputType, IReportParams } from "./types";

import newApi from "../../services/newApi/api";
import type { IEnvelope } from "../../services/newApi/typed";

export const REPORT_INPUT_TYPE_LIST: IInputType[] = ["date", "input", "select"];

export const getReportParams = async (
  reportId: number,
  signal?: AbortSignal,
) => {
  return (
    await newApi.get<IEnvelope<{ params: IReportParams[] }>>(`/reports/${reportId}/params`, {
      ...(signal !== undefined && { signal }),
    })
  ).data.data.params;
};

export const generateReport = async (
  reportId: number,
  params: object,
  signal?: AbortSignal,
) => {
  return await newApi.post<ArrayBuffer>(`/reports/${reportId}/generate`, params, {
    responseType: "arraybuffer",
    ...(signal !== undefined && { signal }),
  });
};

export const generateFilename = (
  baseName: string,
  extension: string,
): string => {
  const formattedDate = new Date()
    .toISOString()
    .replace(/:/g, "-")
    .split(".")[0];
  return `${baseName}-${formattedDate}.${extension}`;
};
